import { DatabaseService } from './database.service';
import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { ObserverService } from './observer.service';
import { APIService } from './api.service';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { StorageService } from './storage.service';

@Injectable()
export class ProductService {

    constructor(
        public alertController: AlertController,
        private router: Router,
        private authService: AuthService,
        private observerService: ObserverService,
        private apiService: APIService,
        private databaseService: DatabaseService,
        private storageService: StorageService
    ) { }

    addProduct(raw_product) {
        return new Promise<void>((resolve, reject) => {
            let product = {};
            let product_categories = [];
            product["id"] = raw_product.id;
            product["title"] = raw_product.title.toString();
            product["allow_sub_products"] = raw_product.allow_sub_products;
            product["weighting"] = raw_product.weighting;
            if(!product['allow_sub_products']) {
                product["track_stock"] = raw_product.track_stock;
                product['quantity_decimal_places'] = raw_product.quantity_decimal_places;
                product['default_quantity'] = raw_product.default_pos_quantity;
                product['quantity_step_interval'] = raw_product.pos_quantity_step_interval;
                if(product['track_stock']) {
                    product["low_available_stock_level"] = raw_product.low_available_stock_level;
                    product["available_stock"] = raw_product.available_stock;
                }
                if(raw_product.sku) {
                    product["sku"] = raw_product.sku.toString();
                }
                if(raw_product.barcode) {
                    product["barcode"] = raw_product.barcode.toString();
                }
            }
            product["tax_type"] = raw_product.tax_type;
            if(raw_product.prices) {
                product["prices"] = raw_product.prices;
            }
            if(raw_product.image) {
                product["image"] = raw_product.image;
            }
            if(raw_product.categories) {
                for (let k = 0; k < raw_product.categories.length; k++) {
                    let product_category = {};
                    product_category["id"] = raw_product.id + raw_product.categories[k].id;
                    product_category["product_id"] = raw_product.id;
                    product_category["category_id"] = raw_product.categories[k].id;
                    product_categories.push(product_category);
                }
            }
            if(raw_product.measurement_unit) {
                product["measurement_unit_id"] = raw_product.measurement_unit.id;
            }
            this.databaseService.product_product
                .add(product)
                .then(() => {
                    this.databaseService.product_product_category
                        .bulkAdd(product_categories)
                        .then(() => {
                            if (raw_product.categories) {
                                product['categories'] = raw_product.categories;
                            }
                            this.observerService.publish("product_added", product);
                            this.storageService.set("products_last_updated_date", new Date().toISOString()).then(() => {}).catch(() => {});
                            resolve();
                        })
                        .catch(() => {
                             reject();
                        });
                })
                .catch(() => {
                    reject();
                });
            // TODO: should add sub products as well
        });
    }

    addSubProduct(raw_sub_product) {
        return new Promise<void>((resolve, reject) => {
            let sub_product = {};
            sub_product['id'] = raw_sub_product.id;
            sub_product['product_id'] = raw_sub_product.product.id;
            sub_product['track_stock'] = raw_sub_product.track_stock;
            sub_product['tax_type'] = raw_sub_product.tax_type;
            sub_product['quantity_decimal_places'] = raw_sub_product.quantity_decimal_places;
            sub_product['default_quantity'] = raw_sub_product.default_pos_quantity;
            sub_product['quantity_step_interval'] = raw_sub_product.pos_quantity_step_interval;
            if(sub_product['track_stock']) {
                sub_product['low_available_stock_level'] = raw_sub_product.low_available_stock_level;
                sub_product['available_stock'] = raw_sub_product.available_stock;
            }
            if(raw_sub_product.prices) {
                sub_product['prices'] = raw_sub_product.prices;
            }
            if(raw_sub_product.sku) {
                sub_product['sku'] = raw_sub_product.sku.toString();
            }
            if(raw_sub_product.barcode) {
                sub_product['barcode'] = raw_sub_product.barcode.toString();
            }
            if(raw_sub_product.product && raw_sub_product.product.image) {
                sub_product['product_image'] = raw_sub_product.product.image;
            }
            if(raw_sub_product.variations) {
                sub_product['variations'] = raw_sub_product.variations;
            }
            if(raw_sub_product.measurement_unit) {
                sub_product["measurement_unit_id"] = raw_sub_product.measurement_unit.id;
            }
            this.databaseService.product_product_sub_product.add(sub_product).then(() => {
                this.observerService.publish("sub_product_added", sub_product);
                this.storageService.set("products_last_updated_date", new Date().toISOString()).then(() => {}).catch(() => {});
                resolve();
            })
            .catch(() => {
                reject();
            });

        });
    }

    addCategories(categories,raw_categories,parent_category_id) {
        for (let i = 0; i < raw_categories.length; i++) {
            let category = {};
            category["id"] = raw_categories[i].id;
            category["parent_category_id"] = parent_category_id;
            category["title"] = raw_categories[i].title;
            category['order'] = i;
            categories.push(category);
            if (raw_categories[i].categories) {
                this.addCategories(categories, raw_categories[i].categories, raw_categories[i].id);
            }
        }
        return categories;
    }

    bulkAddProductCategories(raw_categories) {
        return new Promise<void>((resolve, reject) => {
            if(raw_categories !== undefined) {
                this.databaseService.product_category
                    .clear()
                    .then(() => {
                        let categories = this.addCategories([], raw_categories, null);
                        this.databaseService.product_category
                            .bulkAdd(categories)
                            .then(() => {
                                this.observerService.publish("product_categories_changed", null);
                                this.storageService.set("product_categories_last_updated_date", new Date().toISOString()).then(() => {}).catch(() => {});
                                resolve();
                            })
                            .catch(() => {
                                reject();
                            });
                    })
                    .catch(() => {
                        reject();
                    });
            }
            else {
                resolve();
            }
        });
    }    

    bulkAddProducts(raw_products) {
        return new Promise<void>(async (resolve, reject) => {
            if(raw_products !== undefined) {
                let products = [];
                let sub_products = [];
                let product_categories = [];
                for (let i = 0; i < raw_products.length; i++) {
                    let product = {};
                    product["id"] = raw_products[i].id;
                    product["title"] = raw_products[i].title.toString();
                    product["allow_sub_products"] = raw_products[i].allow_sub_products;
                    product["weighting"] = raw_products[i].weighting;
                    if(!product['allow_sub_products']) {
                        product["track_stock"] = raw_products[i].track_stock;
                        product["quantity_decimal_places"] = raw_products[i].quantity_decimal_places;
                        product["default_quantity"] = raw_products[i].default_pos_quantity;
                        product["quantity_step_interval"] = raw_products[i].pos_quantity_step_interval;
                        if(product["track_stock"]) {
                            product["low_available_stock_level"] = raw_products[i].low_available_stock_level;
                            product["available_stock"] = raw_products[i].available_stock;
                        }
                        if(raw_products[i].sku) {
                            product["sku"] = raw_products[i].sku.toString();
                        }
                        if(raw_products[i].barcode) {
                            product["barcode"] = raw_products[i].barcode.toString();
                        }
                    }
                    product["tax_type"] = raw_products[i].tax_type;
                    if(raw_products[i].prices) {
                        product["prices"] = raw_products[i].prices;
                    }
                    if(raw_products[i].image) {
                        product["image"] = raw_products[i].image;
                    }
                    if(raw_products[i].measurement_unit) {
                        product["measurement_unit_id"] = raw_products[i].measurement_unit.id;
                    }
                    if(raw_products[i].sub_products) {
                        for (let j = 0; j < raw_products[i].sub_products.length; j++) {
                            let sub_product = {};
                            sub_product["id"] = raw_products[i].sub_products[j].id;
                            sub_product["product_id"] = raw_products[i].id;
                            sub_product["track_stock"] = raw_products[i].sub_products[j].track_stock;
                            sub_product["quantity_decimal_places"] = raw_products[i].sub_products[j].quantity_decimal_places;
                            sub_product["default_quantity"] = raw_products[i].sub_products[j].default_pos_quantity;
                            sub_product["quantity_step_interval"] = raw_products[i].sub_products[j].pos_quantity_step_interval;
                            if(sub_product["track_stock"]) {
                                sub_product["low_available_stock_level"] = raw_products[i].sub_products[j].low_available_stock_level;
                                sub_product["available_stock"] = raw_products[i].sub_products[j].available_stock;
                            }
                            sub_product["tax_type"] = raw_products[i].sub_products[j].tax_type;
                            if(raw_products[i].sub_products[j].prices) {
                                sub_product["prices"] = raw_products[i].sub_products[j].prices;
                            }
                            if (raw_products[i].sub_products[j].sku) {
                                sub_product["sku"] = raw_products[i].sub_products[j].sku.toString();
                            }
                            if (raw_products[i].sub_products[j].barcode) {
                                sub_product["barcode"] = raw_products[i].sub_products[j].barcode.toString();
                            }
                            if (raw_products[i].sub_products[j].product && raw_products[i].sub_products[j].product.image) {
                                sub_product["product_image"] = raw_products[i].sub_products[j].product.image;
                            }
                            if (raw_products[i].sub_products[j].variations) {
                                sub_product["variations"] = raw_products[i].sub_products[j].variations;
                            }
                            if(raw_products[i].sub_products[j].measurement_unit) {
                                sub_product["measurement_unit_id"] = raw_products[i].sub_products[j].measurement_unit.id;
                            }
                            sub_products.push(sub_product);
                        }
                    }
                    if (raw_products[i].categories) {
                        for (let k = 0; k < raw_products[i].categories.length; k++) {
                            let product_category = {};
                            product_category["id"] = raw_products[i].id + raw_products[i].categories[k].id;
                            product_category["product_id"] = raw_products[i].id;
                            product_category["category_id"] = raw_products[i].categories[k].id;
                            product_categories.push(product_category);
                        }
                    }
                    products.push(product);
                }
                this.databaseService.product_product_category
                    .clear()
                    .then(() => {
                        this.databaseService.product_product_sub_product
                            .clear()
                            .then(() => {
                                this.databaseService.product_product
                                    .clear()
                                    .then(async () => {
                                        await this.databaseService.product_product
                                            .bulkAdd(products)
                                            .then(() => {
                                                // do nothing
                                            })
                                            .catch(() => {
                                                reject();
                                            });
                                        await this.databaseService.product_product_sub_product
                                            .bulkAdd(sub_products)
                                            .then(() => {
                                                // do nothing
                                            })
                                            .catch(() => {
                                                reject();
                                            });
                                        await this.databaseService.product_product_category
                                            .bulkAdd(product_categories)
                                            .then(() => {
                                                // do nothing
                                            })
                                            .catch(() => {
                                                reject();
                                            });
                                        this.observerService.publish("products_changed", null);
                                        this.storageService.set("products_last_updated_date", new Date().toISOString()).then(() => {}).catch(() => {});
                                        resolve();
                                    })
                                    .catch(() => {
                                        reject();
                                    });
                            })
                            .catch(() => {
                                reject();
                            });
                    })
                    .catch(() => {
                        reject();
                    });
            }
            else {
                resolve();
            }
        });
    }

    deleteProduct(product_id) {
        return new Promise<void>((resolve, reject) => {
            // TODO: should delete sub products as well
            this.databaseService.product_product
                .delete(product_id)
                .then(() => {
                    this.databaseService.product_product_category
                        .where("product_id")
                        .equals(product_id)
                        .delete()
                        .then(() => {
                            this.observerService.publish("product_deleted", product_id);
                            this.storageService.set("products_last_updated_date", new Date().toISOString()).then(() => {}).catch(() => {});
                            resolve();
                        })
                        .catch(() => {
                            reject();
                        });
                })
                .catch(() => {
                    reject();
                });
        });
    }

    deleteSubProduct(sub_product) {
        return new Promise<void>((resolve, reject) => {
            this.databaseService.product_product_sub_product
                .delete(sub_product.id)
                .then(() => {
                    this.observerService.publish("sub_product_deleted", sub_product);
                    this.storageService.set("products_last_updated_date", new Date().toISOString()).then(() => {}).catch(() => {});
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    }

    getCategory(category_id) {
        return new Promise((resolve, reject) => {
            this.databaseService.product_category
                .get(category_id)
                .then((category) => {
                    resolve(category);
                })
                .catch(() => {
                    reject();
                });
        });
    }

    getCategoryChildren(parent_category_id) {
        return new Promise((resolve, reject) => {
            this.databaseService.product_category
                .where("parent_category_id")
                .equals(parent_category_id)
                .toArray()
                .then((categories) => {
                    resolve(categories);
                })
                .catch(() => {
                    reject();
                });
        });
    }

    getCategoryAncestors(ancestors, parent_category_id) {
        return new Promise((resolve, reject) => {
            if (parent_category_id != null) {
                this.databaseService.product_category
                    .get(parent_category_id)
                    .then((category) => {
                        ancestors.unshift(category);
                        this.getCategoryAncestors(ancestors, category.parent_category_id).then((ancestors) => {
                            resolve(ancestors);
                        });
                    });
            }
            else {
                resolve(ancestors);
            }
        });
    }

    getCategoryBreadcrumbs(category_id) {
        return new Promise((resolve, reject) => {
            this.databaseService.product_category
                .get(category_id)
                .then((category) => {
                    let breadcrumbs = [];
                    if (category) {
                        breadcrumbs.push(category);
                        this.getCategoryAncestors(breadcrumbs, category.parent_category_id).then((breadcrumbs) => {
                            resolve(breadcrumbs);
                        });
                    }
                    else {
                        resolve(breadcrumbs);
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    getProduct(product_id) {
        return new Promise((resolve, reject) => {
            this.databaseService.product_product
                .get(product_id)
                .then((product) => {
                    resolve(product);
                })
                .catch(() => {
                    reject();
                });
        });
    }

    getProductByBarcode(barcode) {
        return new Promise(async (resolve, reject) => {
            await this.databaseService.product_product
                .where("barcode")
                .equals(barcode.toString())
                .first()
                .then((product) => {
                    resolve(product);
                })
                .catch(() => {
                    reject();
                });
        });
    }

    getProductsByCategory(category_id) {
        return new Promise((resolve, reject) => {
            this.databaseService.product_product_category
                .where("category_id")
                .equals(category_id)
                .toArray()
                .then((junctions) => {
                    let product_ids = [];
                    for (let i = 0; i < junctions.length; i++) {
                        product_ids.push(junctions[i].product_id);
                    }
                    this.databaseService.product_product
                        // NOTE: We don't use bulkGet as conflicts with Angular model binding somehow
                        .toArray()
                        .then((products) => {
                            let found_products = [];
                            for (let i = 0; i < products.length; i++) {
                                if (product_ids.includes(products[i].id)) {
                                    found_products.push(products[i]);
                                }
                            }
                            resolve(found_products);
                        })
                        .catch(() => {
                            reject();
                        });
                });
        });
    }

    getProductsByKeywords(keywords) {
        return new Promise((resolve, reject) => {
            this.databaseService.product_product_sub_product
            // NOTE: We don't use bulkGet as conflicts with Angular model binding somehow
            .toArray()
            .then((sub_products) => {
                let sub_products_product_lookup = {};
                for (let i = 0; i < sub_products.length; i++) {
                    let sub_product = sub_products[i];                    
                    if (sub_product['sku'] && sub_product['sku'].toString().toLowerCase().indexOf(keywords) !== -1) {
                        sub_products_product_lookup[sub_product['product_id']] = true;
                    }
                    else if (sub_product['barcode'] && sub_product['barcode'].toString().toLowerCase().indexOf(keywords) !== -1) {
                        sub_products_product_lookup[sub_product['product_id']] = true;
                    }
                }
                this.databaseService.product_product
                // NOTE: We don't use bulkGet as conflicts with Angular model binding somehow
                .toArray()
                .then((products) => {
                    let found_products = [];
                    for (let i = 0; i < products.length; i++) {
                        let product = products[i];
                        product['type'] = 'product';
                        if (sub_products_product_lookup[product['id']]) {
                            found_products.push(product);
                        }
                        else if (product['title'].toString().toLowerCase().indexOf(keywords) !== -1) {
                            found_products.push(product);
                        }
                        else if (product['sku'] && product['sku'].toString().toLowerCase().indexOf(keywords) !== -1) {
                            found_products.push(product);
                        }
                        else if (product['barcode'] && product['barcode'].toString().toLowerCase().indexOf(keywords) !== -1) {
                            found_products.push(product);
                        }
                    }
                    resolve(found_products);
                })
                .catch(() => {
                    reject();
                });
            })
            .catch(() => {
                reject();
            });
        });
    }

    getSubProduct(sub_product_id) {
        return new Promise((resolve, reject) => {
            this.databaseService.product_product_sub_product.get(sub_product_id).then((sub_product) => {
                resolve(sub_product);
            })
            .catch(() => {
                reject();
            });
        });
    }

    getSubProductByBarcode(barcode) {
        return new Promise(async (resolve, reject) => {
            await this.databaseService.product_product_sub_product.where("barcode").equals(barcode.toString()).first().then((sub_product) => {
                resolve(sub_product);
            })
            .catch(() => {
                reject();
            });
        });
    }

    getSubProducts(product_id) {
        return new Promise((resolve, reject) => {
            this.databaseService.product_product_sub_product
                .where("product_id")
                .equals(product_id)
                .toArray()
                .then((sub_products) => {
                    resolve(sub_products);
                })
                .catch(() => {
                    reject();
                });
        });
    }

    loadProductCategories() {
        return new Promise<void>((resolve, reject) => {
            this.authService.isLoggedIn().then(() => {
                this.apiService.getProductCategories({}).then((raw_categories) => {
                    this.bulkAddProductCategories(raw_categories).then(() => {
                        resolve();
                    })
                    .catch(() => {
                        reject();
                    });
                })
                .catch((error) => {
                    if(error.status === 400) {
                        this.presentAlert("Problem", "Unknown error", "Unfortunately something went wrong when trying to get product categories.");
                    }
                    else if(error.status === 403) {
                        this.presentAlert("Problem", "Insufficient permissions", "You don't have permission to view product categories.");
                    }
                    else if(error.status === 404 || error.status === 0) {
                        this.presentAlert("Problem", "Unavailable", "Unfortunately we're unable to retrieve product categories at this time.");
                    }
                    reject();
                });
            })
            .catch(() => {
                this.router.navigate(["switch-account"], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
    }

    updateProduct(raw_product) {
        return new Promise<void>((resolve, reject) => {
            this.databaseService.product_product.delete(raw_product.id).then(() => {
                this.databaseService.product_product_category.where("product_id").equals(raw_product.id).delete().then(() => {
                    let product = {};
                    let product_categories = [];
                    product["id"] = raw_product.id;
                    product["title"] = raw_product.title.toString();
                    product["allow_sub_products"] = raw_product.allow_sub_products;
                    if (!product['allow_sub_products']) {
                        product["track_stock"] = raw_product.track_stock;
                        product['quantity_decimal_places'] = raw_product.quantity_decimal_places;
                        product['default_quantity'] = raw_product.default_pos_quantity;
                        product['quantity_step_interval'] = raw_product.pos_quantity_step_interval;
                        if (product['track_stock']) {
                            product["low_available_stock_level"] = raw_product.low_available_stock_level;
                            product["available_stock"] = raw_product.available_stock;
                        }
                        if (raw_product.sku) {
                            product["sku"] = raw_product.sku.toString();
                        }
                        if (raw_product.barcode) {
                            product["barcode"] = raw_product.barcode.toString();
                        }
                    }
                    product["tax_type"] = raw_product.tax_type;
                    product["weighting"] = raw_product.weighting;
                    if(raw_product.prices) {
                        product["prices"] = raw_product.prices;
                    }
                    if (raw_product.image) {
                        product["image"] = raw_product.image;
                    }
                    if (raw_product.categories) {
                        for (let k = 0; k < raw_product.categories.length; k++) {
                            let product_category = {};
                            product_category["id"] = raw_product.id + raw_product.categories[k].id;
                            product_category["product_id"] = raw_product.id;
                            product_category["category_id"] = raw_product.categories[k].id;
                            product_categories.push(product_category);
                        }
                    }
                    if(raw_product.measurement_unit) {
                        product["measurement_unit_id"] = raw_product.measurement_unit.id;
                    }
                    this.databaseService.product_product.add(product).then(() => {
                        this.databaseService.product_product_category.bulkAdd(product_categories).then(() => {
                            if (raw_product.categories) {
                                product['categories'] = raw_product.categories;
                            }
                            this.observerService.publish("product_updated", product);
                            this.storageService.set("products_last_updated_date", new Date().toISOString()).then(() => { }).catch(() => { });
                            resolve();
                        })
                        .catch(() => {
                            reject();
                        });
                    })
                    .catch(() => {
                        reject();
                    });

                })
                .catch(() => {
                    reject();
                });
            })
            .catch(() => {
                reject();
            });
        });
    }

    updateProductAvailableStock(product) {
        return new Promise<void>((resolve, reject) => {
            this.databaseService.product_product
                .update(product.id, product)
                .then(() => {
                    this.observerService.publish("product_available_stock_updated", product);
                    this.storageService.set("products_last_updated_date", new Date().toISOString()).then(() => {}).catch(() => {});
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    }

    updateSubProduct(raw_sub_product) {
        return new Promise<void>((resolve, reject) => {
            this.databaseService.product_product_sub_product.delete(raw_sub_product.id).then(() => {
                let sub_product = {};
                sub_product['id'] = raw_sub_product.id;
                sub_product['product_id'] = raw_sub_product.product.id;
                sub_product['track_stock'] = raw_sub_product.track_stock;
                sub_product['tax_type'] = raw_sub_product.tax_type;
                sub_product['quantity_decimal_places'] = raw_sub_product.quantity_decimal_places;
                sub_product['default_quantity'] = raw_sub_product.default_pos_quantity;
                sub_product['quantity_step_interval'] = raw_sub_product.pos_quantity_step_interval;
                if(sub_product['track_stock']) {
                    sub_product['low_available_stock_level'] = raw_sub_product.low_available_stock_level;
                    sub_product['available_stock'] = raw_sub_product.available_stock;
                }
                if(raw_sub_product.prices) {
                    sub_product['prices'] = raw_sub_product.prices;
                }
                if(raw_sub_product.sku) {
                    sub_product['sku'] = raw_sub_product.sku.toString();
                }
                if(raw_sub_product.barcode) {
                    sub_product['barcode'] = raw_sub_product.barcode.toString();
                }
                if(raw_sub_product.product && raw_sub_product.product.image) {
                    sub_product['product_image'] = raw_sub_product.product.image;
                }
                if(raw_sub_product.variations) {
                    sub_product['variations'] = raw_sub_product.variations;
                }
                if(raw_sub_product.measurement_unit) {
                    sub_product['measurement_unit_id'] = raw_sub_product.measurement_unit.id;
                }
                this.databaseService.product_product_sub_product.add(sub_product).then(() => {
                    this.observerService.publish("sub_product_updated", sub_product);
                    this.storageService.set("products_last_updated_date", new Date().toISOString()).then(() => {}).catch(() => {});
                    resolve();
                })
                .catch(() => {
                    reject();
                });
            })
            .catch(() => {
                reject();
            });
        });
    }

    updateSubProductAvailableStock(sub_product) {
        return new Promise<void>((resolve, reject) => {
            this.databaseService.product_product_sub_product
                .update(sub_product.id, sub_product)
                .then(() => {
                    this.observerService.publish("sub_product_available_stock_updated", sub_product);
                    this.storageService.set("products_last_updated_date", new Date().toISOString()).then(() => {}).catch(() => {});
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    }

    async presentAlert(header, sub_header, message) {
        const alert = await this.alertController.create({
            header: header,
            subHeader: sub_header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

}
